import { getRouterSelectors } from '@ngrx/router-store';
import { Action, MetaReducer } from '@ngrx/store';
import { localStorageSyncMetaReducer } from './meta.reducer';
import { OnInitEffects } from '@ngrx/effects';
import { AuthActions } from './auth-feature';

export class AppRehydrateEffects implements OnInitEffects {
  ngrxOnInitEffects(): Action {
    return AuthActions.rehydrateSession();
  }
}

export * from './modal-feature';
export * from './toast-feature';
export * from './auth-feature';
export * from './business-account-feature';
export * from './feature-flag-feature';
export * from './exception-management-feature';
export * from './financial-account-feature';
export * from './team-members-feature';
export * from './transaction-feature';

/* eslint-disable-next-line @typescript-eslint/no-empty-object-type */
export const metaReducers: MetaReducer<{}, Action<string>>[] = [localStorageSyncMetaReducer];

export const {
  selectCurrentRoute, // select the current route
  selectFragment, // select the current route fragment
  selectQueryParams, // select the current route query params
  selectQueryParam, // factory function to select a query param
  selectRouteParams, // select the current route params
  selectRouteParam, // factory function to select a route param
  selectRouteData, // select the current route data
  selectRouteDataParam, // factory function to select a route data param
  selectUrl, // select the current url
  selectTitle, // select the title if available
} = getRouterSelectors();
